import axios from '../api/axios';
const BASE_URL = '/api/nsection-b4';

export interface ReferenceItem { reference: string; }

export interface NsectionB4Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  based_methodologies: ReferenceItem[] | null;
  methodological_tools: ReferenceItem[] | null;
  information_sources: ReferenceItem[] | null;
  nsection_b4_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB4Update {
  based_methodologies?: ReferenceItem[];
  methodological_tools?: ReferenceItem[];
  information_sources?: ReferenceItem[];
}

const nsectionB4Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB4Detail | null> => {
    const r = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return r.data;
  },
  update: async (proposalId: number, data: NsectionB4Update): Promise<NsectionB4Detail> => {
    const r = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return r.data;
  },
};
export default nsectionB4Service;
